import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";

export default function About() {
  const { copy } = useLanguage();
  return (
    <main className="pt-28 pb-24 sm:pt-36" data-testid="about-page">
      <Seo title={copy.seo.about.title} description={copy.seo.about.desc} type="profile" />
      <div className="max-w-3xl mx-auto px-5">
        <Reveal>
          <div className="text-center">
            <div className="relative mx-auto max-w-[220px] mb-10">
              <div className="absolute -inset-2.5 rounded-full bg-clay/15 rotate-3" aria-hidden="true" />
              <img
                src="/giada-v2.jpg"
                alt="Giada, coach de nutrición y bienestar, en su estudio"
                data-testid="about-page-portrait"
                className="relative rounded-full object-cover object-[62%_center] w-full aspect-square shadow-lg border-4 border-white"
              />
            </div>
            <p className="text-xs font-mono uppercase tracking-[0.22em] text-clay font-semibold mb-3">{copy.about.eyebrow}</p>
            <h1 className="font-serif font-semibold text-4xl sm:text-5xl text-ink tracking-tight">{copy.about.title}</h1>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-muted leading-relaxed">{copy.about.p1}</p>
          <p className="mt-4 text-muted leading-relaxed">{copy.about.p2}</p>
          <p className="mt-4 text-muted leading-relaxed">{copy.about.p3}</p>
          <ul className="mt-8 grid gap-3 sm:grid-cols-2">
            {copy.about.credentials.map((cr, i) => (
              <li key={i} className="flex items-center gap-2.5 rounded-2xl bg-white border border-border px-4 py-3 text-sm text-ink/80" data-testid={`credential-${i}`}>
                <Check size={15} className="text-clay shrink-0" /> {cr}
              </li>
            ))}
          </ul>
          <div className="text-center">
            <Link
              to="/prenota"
              data-testid="about-page-cta"
              className="mt-9 inline-flex items-center gap-2 rounded-full bg-clay px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-clay-dark hover:-translate-y-0.5 hover:shadow-lg"
            >
              {copy.nav.cta} <ArrowRight size={15} />
            </Link>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
